import { render, staticRenderFns } from "./rec_dptch_rcrds.vue?vue&type=template&id=1ae257b6&scoped=true&"
import script from "./rec_dptch_rcrds.vue?vue&type=script&lang=js&"
export * from "./rec_dptch_rcrds.vue?vue&type=script&lang=js&"
import style0 from "./rec_dptch_rcrds.vue?vue&type=style&index=0&id=1ae257b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae257b6",
  null
  
)

export default component.exports